<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">选择入住老人</div>
                <div style="folat:right">
                    <el-button type="danger" @click="closeSelf">关闭</el-button>
                </div>
            </div>
            <div class="modal-body" :style="bodyStyle">
                <el-row>
                    <div style="float:right">
                        <el-input  placeholder="请输入姓名" v-model="name" clearable style="margin:0 10px;width:200px"></el-input>
                        <!-- <el-select
                            v-model="status"
                             style="margin:0 10px;width:200px"
                            placeholder="请选择状态">
                            <el-option
                                v-for="(item,i) in statusValue"
                                :key="i"
                                :label="item"
                                :value="i">
                            </el-option>
                        </el-select> -->
                        <el-button type="primary" icon="el-icon-search" @click="getElderly">搜索</el-button>
                    </div>
                </el-row>
                <el-row style="margin-top:20px">
                    <el-col :span="24">
                        <el-table
                            :data="elderlyInfo"
                            style="width: 100%" border :height="th">
                            <el-table-column label="姓名" prop="name" width="100"></el-table-column>
                            <el-table-column label="手机号" prop="phone"></el-table-column>
                            <el-table-column label="身份证号" prop="idCard"></el-table-column>
                            <el-table-column label="部门" prop="departmentName"></el-table-column>
                            <el-table-column label="地址" prop="areaName" ></el-table-column>
                            <el-table-column label="详细地址" prop="address" ></el-table-column>
                            <el-table-column label="操作" width="300">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click.native.prevent="handleAdd(scope.$index, scope.row)">入住</el-button>
                                    <!-- <el-button type="danger" size="small" @click.native.prevent="handleZiXuanAdd(scope.$index, scope.row)">自选收费入住</el-button> -->
                                </template>
                            </el-table-column>
                        </el-table>
                        
                    </el-col>
                </el-row>
                <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
            </div>
        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:setmealList="setmealList" v-bind:ListBerth="ListBerth" v-on:getList="getList"></Add>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import Add from "./Add"
    export default {
        name: 'GetElderly',
        props:['ListBerth','setmealList'],
        data() {
            return {
                showModalAdd:false,
                showModalZiXuanAdd:false,
                multipleSelection:'',
                name:'',
                status:0,
                checked:false,
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                loading: false, 
                elderlyInfo:[],
                statusValue:['老人状态','正常','禁用'],
                totalItems:0,
                pageSize: 20,
                currentPage: 1,
                bodyStyle:"height:"+(this.$store.state.tableHeight+50)+'px',
                th:this.$store.state.tableHeight,
                rules:{
                }
            }
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.bodyStyle = "height:"+(val+50)+'px';
                this.th=val
            },
        },
        components:{
            Add
        },
        methods: {
            init(){
                this.getElderly()
            },
            closeSelf() {
                this.$emit("closeGetElderly");
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            changeThreeDay(){
                this.checked?this.searchForm.isAdd=1:this.searchForm.isAdd=0;
                this.getElderly()
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getElderly();
            },
            handleAdd(index, row) {
                this.$refs.myAdd.init(row);
                this.showModalAdd = !this.showModalAdd;
            },
            handleZiXuanAdd(index,row){
                this.$refs.myZiXuanAdd.init(row);
                this.showModalZiXuanAdd = !this.showModalZiXuanAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            closeZiXuanAdd:function(){
                this.showModalZiXuanAdd = !this.showModalZiXuanAdd;
            },
            elderlyTypes(row){
                if(row.elderlyType == 0){
                    return "政府购买服务";
                }
                if(row.elderlyType == 1){
                    return "有偿服务";
                }
                return "其它";
            },
            getList(){
                this.$emit('getList')
                this.$emit("closeGetElderly");
            },
            allStatus(row,status){
                for(var i in status){
                    if(status[i].value==row){
                        return status[i].label
                    }
                }
                return "其它";
            },
            getZoneValue(val){
                this.searchForm.zoneCode=val
            },
            getElderly(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Elderly/GetListByNotCheckin",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.elderlyInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 50px;
        right: 0;
        bottom: 0;
        left: 200px;
        background-color: rgba(0,0,0,.3);
        display: flex;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  none;
            border-radius: 0;
            width: 100%;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 20px 0;
                z-index: 99;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: center;
                padding: 15px;
                display: flex;
                .el-button{
                    width: 15%;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
